import config from '@/utils/Config'
import {get, post } from '@/utils/request'

export function getVersionList(params = {}) {
    return get(config.BASE_URL, config.getVersionListUrl, params)
}